import React from "react";
import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  title?: string;
  description?: string;
  className?: string;
  compact?: boolean;
  showBorder?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  title, 
  description,
  className = "",
  compact = false,
  showBorder = true
}) => {
  const { t } = useTranslation("common");
  const borderClasses = showBorder ? "bg-muted/30 border-2 border-dashed border-muted-foreground/30 rounded-lg" : "";
  
  return (
    <div className={`flex items-center justify-center ${compact ? "py-8" : "py-12"} ${borderClasses} ${className}`}>
      <div className="flex flex-col items-center justify-center text-center text-muted-foreground px-4">
        <div className={compact ? "text-sm" : "text-base"}>
          <div className="font-medium">{title ?? t("emptyState.defaultTitle")}</div>
          {description && (
            <div className={`text-muted-foreground/70 mt-1 ${compact ? "text-xs" : "text-sm"}`}>
              {description}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
